import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ConfirmationResult } from 'firebase/auth';
import { FirebaseService } from 'src/app/commons/firebase.service';
import { FunctionsService } from 'src/app/data/functions.service';
import { PessoaValidador } from 'src/app/validators/pessoa-validador';

@Component({
  selector: 'app-acesso-cliente',
  templateUrl: './acesso-cliente.component.html',
  styleUrls: ['./acesso-cliente.component.css']
})
export class AcessoClienteComponent implements OnInit {
  @ViewChild('acessoClienteStepper') acessoClienteStepper: MatStepper;
  @Input() subtitulo: string;
  @Output() acessoFinalizado = new EventEmitter();

  public acessoFormGroup: UntypedFormGroup;
  public confirmacaoFormGroup: UntypedFormGroup;
  public loading: boolean = false;
  public cliente: any;
  public confirmacao: ConfirmationResult;


  constructor(
    private firebase: FirebaseService,
    private functions: FunctionsService,
    private formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(): void {

    this.acessoFormGroup = this.formBuilder.group({
      email: [{ value: '', disabled: false }, [
        Validators.required,
        Validators.email
      ]],
      senha: [{ value: '', disabled: false }, [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(60)
      ]]
    });

    this.confirmacaoFormGroup = this.formBuilder.group({
      codigo: [{ value: '', disabled: false }, [
        Validators.required
      ]]
    });
  }

  anterior() {
    this.acessoClienteStepper.previous();
  }

  aindaNaoTenhoRegistro() {
    this.acessoFinalizado.emit('registrar');
  }

  recuperarSenha() {
    this.firebase.recuperarSenha(
      this.acessoFormGroup.controls['email'].value
    )
      .then(res => {
        alert('Enviado um email para recuperação de senha')
      })
      .catch(error => {
        alert('Ops, houve um erro ao recuperar a senha')
        console.error(error)
      })
      .finally(() => {

      })
  }

  verificarUsuario() {
    if (this.acessoFormGroup.invalid) {
      alert('Por favor, preencha todos os campos obrigatórios');
      return;
    }

    this.loading = true;
    this.acessoFormGroup.disable();

    const payload: any = {};

    Object.keys(this.acessoFormGroup.controls).forEach(key => {
      payload[key] = this.acessoFormGroup.controls[key].value;
    });

    // Usa o FirebaseService (Auth modular), o mesmo caminho emulator-aware do
    // registro-cliente e do initApp() — em modo offline (environment.useEmulators)
    // autentica no Auth emulator local; em dev/staging/prod, no Firebase real.
    // O onAuthStateChanged do FirebaseService cuida de gravar o __token__ e
    // carregar o profile.
    this.firebase.entrarComEmailESenha(
      payload.email, payload.senha
    )
      .then(res => {
        this.acessoFinalizado.emit('finalizado');
      })
      .catch(error => {
        alert('O usuário ou senha estão incorretos.')
        console.error(error)
      })
      .finally(() => {
        this.loading = false;
        this.acessoFormGroup.enable();
      });
  }

  verificarCodigoSMS() {
    if (this.confirmacaoFormGroup.invalid) {
      alert('Por favor, informe o código de verificação');
      return;
    }

    this.loading = true;
    this.confirmacaoFormGroup.disable();
    this.confirmacao.confirm(this.confirmacaoFormGroup.controls['codigo'].value)
      .then(res => {
        this.acessoFinalizado.emit('finalizado');
      })
      .catch(error => {
        alert('Ops, não pudemos validar o código. Por favor, tente de novo.')
        console.error(error)
      })
      .finally(() => {
        this.confirmacaoFormGroup.enable();
        this.loading = false;
      })
  }

  checkSubmit(event: any) {
    if (event.keyCode === 13 || event.keyCode === 13) {
      this.verificarUsuario();
    }
  }

}
